"use strict";

module.exports = {
  title: 'HIVEPlace'
};